import actions from './actions'

const initialState = {
  webhooksList: [],
  newWebhooksList: [],
  triggersList: [],
  newTriggersList: [],
  webhooksActive: [],
  newWebhooksActive: [],
  webhooksListTotal: 0,
  newWebhooksListTotal: 0,
  webhooksListPagination: {},
  newWebhooksListPagination: {},
  areWebhooksLoading: true,
  areWebhooksLegacyLoading: true,
  webhookSearchText: '',
}

export default function webhooksReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload }
    default:
      return state
  }
}
